export function asKeyOf<T>(k: keyof T) : keyof T {
    return k
}